import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from "../common/page-title/index";
import InlineCKEditor from '../common/editor/inline-editor';
import ImageEditor from '../common/editor/image-editor';
import { loadPageContent } from '../../actions/content';

import './styles.css';

class HowToEarn extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {
    this.props.dispatch(loadPageContent('api/pages/how_to_earn'));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent('api/pages/how_to_earn'));
  };

  render() {
    return (
      <Grid fluid className="how-to-earn">
        <Row>
          <Col lg={12}>
            <PageTitle>How to earn</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier="how-to-earn_how_to_earn_header"
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents["how-to-earn_how_to_earn_header"]}/>
          </Col>
        </Row>
        <Row>
          <Grid fluid className="editable-list">
            <Row>
              <Col lg={2} md={3} sm={4} xs={12}>
                <ImageEditor identifier="how-to-earn_how_to_earn_image_1"
                             onContentSaved={this.handleContentSaved}
                             contents={this.props.contents["how-to-earn_how_to_earn_image_1"]}/>
              </Col>
              <Col lg={10} md={7} sm={8} xs={12}>
                <InlineCKEditor identifier="how-to-earn_how_to_earn_text_1"
                                onContentSaved={this.handleContentSaved}
                                contents={this.props.contents["how-to-earn_how_to_earn_text_1"]}/>
              </Col>
            </Row>
            <Row>
              <Col lg={2} md={3} sm={4} xs={12}>
                <ImageEditor identifier="how-to-earn_how_to_earn_image_2"
                             onContentSaved={this.handleContentSaved}
                             contents={this.props.contents["how-to-earn_how_to_earn_image_2"]}/>
              </Col>
              <Col lg={10} md={7} sm={8} xs={12}>
                <InlineCKEditor identifier="how-to-earn_how_to_earn_text_2"
                                onContentSaved={this.handleContentSaved}
                                contents={this.props.contents["how-to-earn_how_to_earn_text_2"]}/>
              </Col>
            </Row>
            <Row>
              <Col lg={2} md={3} sm={4} xs={12}>
                <ImageEditor identifier="how-to-earn_how_to_earn_image_3"
                             onContentSaved={this.handleContentSaved}
                             contents={this.props.contents["how-to-earn_how_to_earn_image_3"]}/>
              </Col>
              <Col lg={10} md={7} sm={8} xs={12}>
                <InlineCKEditor identifier="how-to-earn_how_to_earn_text_3"
                                onContentSaved={this.handleContentSaved}
                                contents={this.props.contents["how-to-earn_how_to_earn_text_3"]}/>
              </Col>
            </Row>
            <Row>
              <Col lg={2} md={3} sm={4} xs={12}>
                <ImageEditor identifier="how-to-earn_how_to_earn_image_4"
                             onContentSaved={this.handleContentSaved}
                             contents={this.props.contents["how-to-earn_how_to_earn_image_4"]}/>
              </Col>
              <Col lg={10} md={7} sm={8} xs={12}>
                <InlineCKEditor identifier="how-to-earn_how_to_earn_text_4"
                                onContentSaved={this.handleContentSaved}
                                contents={this.props.contents["how-to-earn_how_to_earn_text_4"]}/>
              </Col>
            </Row>
          </Grid>
        </Row>

      </Grid>
    );

  }
}

const mapStateToProps = (state) => {
  return {
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(HowToEarn);



// WEBPACK FOOTER //
// ./src/components/how-to-earn/index.jsx